import React from 'react'
// import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { routePrefix } from '../../config';
import InventoryView from './inventoryCalendarView'
import DayLevelView from './dayLevelView'
import RejectionReasons from './rejectionReasons'
import { opdbGTM } from '../../utils/pulseUtils';


class InventoryViewContainer extends React.Component {

  componentDidMount() {
    document.title = 'Inventory View';
    opdbGTM.tabClicked('od_inventory_view_tab_clicked');
  }

  render() {
    return (
        <Switch>
          <Route exact path={routePrefix + '/inventory-view'} component={InventoryView} />
          <Route exact path={routePrefix + '/inventory-view/daylevel'} component={DayLevelView}/>
          <Route exact path={routePrefix + '/inventory-view/reasons'} component={RejectionReasons}/>
        </Switch>
    )
  }
}

InventoryViewContainer.propTypes = {}

export default (InventoryViewContainer)
